mutation updateOnboardingCompanyIsReferenceCustomer(
  $input: UpdateOnboardingCompanyIsReferenceCustomer!
) {
  isReferenceCustomer: updateOnboardingCompanyIsReferenceCustomer(input: $input) {
    id
    isReferenceCustomer
  }
}
